import {
    normalizeNumbersWithGroups,
    integerToStringNumberWithIntlGroups,
    roundTwoDecimalPlaces
} from '../../../helpers/normalizers';

export function normalizeSliderValue(value, max, min) {
    return ((value - min) / (max - min)) * 1000;
}

export function denormlizeSliderValue(sliderValue, max, min) {
    return (sliderValue / 1000) * (max - min) + min;
}

export function denormlizeSliderValueAmount(sliderValue, max, min) {
    //TODO: this should be improved in that it should be calculated based on the min/max as opposed to rounding
    let roundingIncrement = 100;
    if (max <= 500) {
        roundingIncrement = 50;
    }

    if (
        Math.floor(sliderValue / roundingIncrement) * roundingIncrement <=
        min
    ) {
        return min;
    }

    if (Math.ceil(sliderValue / roundingIncrement) * roundingIncrement >= max) {
        return max;
    }

    const roundedSliderValue = roundSliderValue(sliderValue, max);
    if (roundedSliderValue < min) return min;

    return roundedSliderValue;
}

export function roundSliderValue(value, max) {
    let sliderValue = value;

    if (max <= 500) {
        return Math.round(value / 50) * 50;
    }

    if (value < 5000) sliderValue = Math.round(value / 100) * 100;

    if (value >= 5000 && value < 20000)
        sliderValue = Math.round(value / 500) * 500;

    if (value >= 20000 && value < 50000)
        sliderValue = Math.round(value / 1000) * 1000;

    if (value >= 50000) sliderValue = Math.round(value / 5000) * 5000;

    return sliderValue;
}

export function normalizeInputValue(value, max, min, locale) {
    let inputValue = value;
    if (value.length === 0 && typeof value === 'string') return inputValue;
    if (value.length > 0 && typeof value === 'string')
        inputValue = normalizeNumbersWithGroups(value);
    if (value >= max) inputValue = max;
    return integerToStringNumberWithIntlGroups(inputValue, locale);
}

export function denormalizeInputValue(value) {
    let inputValue = value.replace(/[^0-9.,]+/, '');
    return normalizeNumbersWithGroups(inputValue);
}

export function serialiseAndRoundInputValue(value, max, min) {
    let inputValue = value;
    if (typeof value === 'string') {
        inputValue = normalizeNumbersWithGroups(value);
    }
    if (inputValue >= max) inputValue = max;
    if (inputValue <= min) inputValue = min;
    return roundTwoDecimalPlaces(inputValue);
}
